import React from "react";
import { UniversalEntityPage } from "@/components/shared/UniversalEntityPage";
import { useTimeEntryHooks } from "@/lib/hooks/api/time-entries/time-entry-hooks";
import { getEntityTableConfig } from "@/lib/entity-registry";
import type { Time_Entries } from "@/src/gql/graphql";

const TIME_ENTRY_CONFIG = getEntityTableConfig<Time_Entries>("time_entries");

interface CompanyTimeEntriesProps {
  companyId: string;
  companyName: string;
  className?: string;
}

export const CompanyTimeEntries: React.FC<CompanyTimeEntriesProps> = ({
  companyId,
  companyName,
  className = "",
}) => {
  const timeEntryHooks = useTimeEntryHooks();

  return (
    <div className={className}>
      <UniversalEntityPage
        entityName="time_entries"
        config={TIME_ENTRY_CONFIG}
        hooks={timeEntryHooks}
        filterPreset="all"
        title={`Time Entries for ${companyName}`}
        description={`View all time entries for ${companyName}`}
        storageKey={`company-${companyName.toLowerCase().replace(/\s+/g, "-")}-time-entries-column-preferences`}
        customFilters={{ company_id: companyId }}
        showHeader={false}
      />
    </div>
  );
};
